export default (t) => [
    {
        route: 'certificates.index',
        label: t('navigation.certificates_index'),
        showInSidebar: true
    },
    {
        route: 'certificates.advanced-search.index',
        label: t('navigation.certificates_advanced_search'),
        showInSidebar: false
    },
    {
        route: 'certificates.advanced-search.show',
        label: t('navigation.certificates_advanced_search_results'),
        showInSidebar: false
    },
    {
        route: 'certificates.show',
        label: t('navigation.certificates_details'),
        showInSidebar: false
    }
]
